import { Routes } from "@angular/router";

export const archiveRoutes: Routes = [
  {
    path: "",
    loadChildren: () => import("./domains/archive/archive.routes").then(m => m.archiveRoutes),
  },
];
